import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../mock";

const ServiceCard = ({ svc, index = 0 }) => {
  return (
    <Link
      to={svc.path}
      className="group relative overflow-hidden rounded-2xl bg-white shadow-md hover:shadow-2xl transition-all duration-500 flex flex-col"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="relative h-56 overflow-hidden">
        <img
          src={IMAGES[svc.image]}
          alt={svc.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-transparent to-transparent" />
        <div className="absolute bottom-3 left-4 right-4 flex justify-between items-end">
          <h3 className="text-white text-xl font-bold drop-shadow">{svc.title}</h3>
          <span className="px-2.5 py-1 bg-orange-500 text-white text-xs font-bold rounded-full">
            {svc.price}
          </span>
        </div>
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-2">
          {svc.unit}
        </div>
        <p className="text-slate-600 text-sm mb-4 flex-1">{svc.desc}</p>
        <div className="flex items-center gap-2 text-orange-600 font-semibold text-sm group-hover:gap-3 transition-all">
          Learn more <ArrowRight size={16} />
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;
